import script from "./CaskWebFab.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskWebFab.vue?vue&type=script&setup=true&lang=js"

import "./CaskWebFab.vue?vue&type=style&index=0&id=d14f7fe8&lang=scss&scoped=true"
import "./CaskWebFab.vue?vue&type=style&index=1&id=d14f7fe8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d14f7fe8"]])

export default __exports__
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFab,QFabAction,QBtn});
